<div class="grid grid-cols-12 my-20">
  <div class="col-start-2 col-span-10">
    <h1 class="self-stretch text-center justify-start text-gray-900 text-4xl font-extrabold font-['Inter'] leading-[54px]">
      Termos e Condições de Uso - Casato Brasil
    </h1>
    <p class="text-center justify-start text-gray-500 text-xl font-normal font-['Inter'] leading-loose">
      Última atualização: 6 de maio de 2026
    </p>

    <div class="self-stretch justify-start mt-20 text-gray-500 text-base font-normal font-['Inter'] leading-normal">
      <section class="mt-6">
        <h2 class="font-bold">1. Introdução</h2>
        <p class="mt-1">
          Estes Termos e Condições de Uso (“Termos”) regulam o acesso e a utilização da plataforma Casato Brasil (“Plataforma”).
        </p>
        <p class="mt-1">
          Ao acessar, cadastrar-se ou utilizar a Plataforma, o usuário declara que leu, compreendeu e concorda integralmente com estes Termos. Caso não concorde, não deverá utilizar os serviços.
        </p>
        <p class="mt-1">
          A Plataforma é operada por Muse Digital, empresa regularmente constituída nos Países Baixos, responsável pela operação comercial da marca Casato Brasil.
        </p>
        <p class="mt-1">
          “Casato Brasil” é marca utilizada para fins comerciais pela referida empresa.
        </p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">2. Natureza dos Serviços</h2>

        <h3 class="mt-4 font-bold">2.1</h3>
        <p class="mt-1">A Plataforma disponibiliza ferramentas tecnológicas para:</p>
        <ul class="mt-1 list-disc pl-6">
          <li>Consolidação e organização de dados públicos sobre imóveis em leilão</li>
          <li>Simulação estimativa de custos e cenários financeiros</li>
          <li>Envio de alertas automatizados relacionados a oportunidades e prazos</li>
        </ul>

        <h3 class="mt-4 font-bold">2.2 Serviços informativos</h3>
        <p class="mt-1">
          Os serviços possuem caráter exclusivamente informativo, estimativo e de apoio à tomada de decisão.
        </p>

        <h3 class="mt-4 font-bold">2.3 A Casato não realiza:</h3>
        <ul class="mt-1 list-disc pl-6">
          <li>Organização, intermediação ou participação em leilões</li>
          <li>Representação de leiloeiros, instituições financeiras ou vendedores</li>
          <li>Recebimento de valores relacionados a arrematações</li>
          <li>Consultoria jurídica, financeira, imobiliária ou de investimentos</li>
        </ul>

        <h3 class="mt-4 font-bold">2.4 Ausência de recomendação</h3>
        <p class="mt-1">
          As informações disponibilizadas não constituem recomendação de investimento, promessa de rentabilidade ou garantia de resultado.
        </p>

        <h3 class="mt-4 font-bold">2.5 Responsabilidade do usuário</h3>
        <p class="mt-1">
          A Plataforma não substitui diligência própria do usuário. O usuário é integralmente responsável por validar informações, analisar riscos e buscar orientação profissional antes de participar de qualquer leilão.
        </p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">3. Cadastro e Elegibilidade</h2>

        <h3 class="mt-4 font-bold">3.1 Informações cadastrais</h3>
        <p class="mt-1">
          Para utilizar determinados recursos da Plataforma, o usuário poderá precisar criar uma conta e fornecer informações verdadeiras, completas e atualizadas.
        </p>

        <h3 class="mt-4 font-bold">3.2 Idade mínima</h3>
        <p class="mt-1">O uso é permitido apenas a maiores de 18 anos.</p>

        <h3 class="mt-4 font-bold">3.3 Credenciais de acesso</h3>
        <p class="mt-1">
          O usuário é responsável pela confidencialidade de suas credenciais de acesso e por toda atividade realizada em sua conta.
        </p>

        <h3 class="mt-4 font-bold">3.4 Uso pessoal</h3>
        <p class="mt-1">
          O acesso à conta é pessoal e intransferível, salvo autorização expressa da Casato.
        </p>

        <h3 class="mt-4 font-bold">3.5 Infraestrutura de autenticação</h3>
        <p class="mt-1">
          A criação e gestão de contas poderá utilizar serviços de infraestrutura e autenticação operados por terceiros, incluindo Amazon Web Services ou fornecedores equivalentes.
        </p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">4. Teste Gratuito e Assinaturas</h2>

        <h3 class="mt-4 font-bold">4.1 Período gratuito</h3>
        <p class="mt-1">
          A Plataforma poderá oferecer período de teste gratuito, conforme divulgado no momento da contratação.
        </p>

        <h3 class="mt-4 font-bold">4.2 Conversão em plano pago</h3>
        <p class="mt-1">
          Quando informado no momento da contratação, encerrado o período gratuito, a assinatura poderá ser convertida automaticamente em plano pago mediante o método de pagamento cadastrado, salvo cancelamento prévio realizado antes do término do teste grátis.
        </p>

        <h3 class="mt-4 font-bold">4.3 Limitações promocionais</h3>
        <p class="mt-1">
          A Casato poderá limitar o acesso ao período de teste gratuito por usuário, dispositivo, meio de pagamento, endereço IP ou outros critérios técnicos razoáveis, com o objetivo de prevenir uso indevido ou obtenção repetida de benefícios promocionais.
        </p>

        <h3 class="mt-4 font-bold">4.4 Renovação automática</h3>
        <p class="mt-1">
          Planos mensais e anuais serão renovados automaticamente ao final de cada ciclo correspondente, salvo cancelamento realizado antes da próxima data de cobrança.
        </p>

        <h3 class="mt-4 font-bold">4.5 Cancelamento</h3>
        <p class="mt-1">
          O cancelamento impede cobranças futuras, preservando o acesso até o término do ciclo já contratado, salvo disposição diversa expressamente informada.
        </p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">5. Pagamentos</h2>

        <h3 class="mt-4 font-bold">5.1 Processamento de pagamentos</h3>
        <p class="mt-1">
          Os pagamentos realizados na Plataforma são processados por provedores certificados, incluindo Stripe, ou outros parceiros equivalentes.
        </p>

        <h3 class="mt-4 font-bold">5.2 Dados financeiros</h3>
        <p class="mt-1">
          Os dados completos de cartão de crédito e instrumentos de pagamento são processados diretamente pelo provedor de pagamento e não são armazenados pela Casato, salvo informações limitadas relacionadas ao status da assinatura e confirmação de pagamento.
        </p>

        <h3 class="mt-4 font-bold">5.3 Cobrança recorrente</h3>
        <p class="mt-1">
          Ao contratar plano pago, o usuário autoriza expressamente cobranças recorrentes correspondentes ao plano selecionado, inclusive renovações automáticas, conforme estes Termos.
        </p>

        <h3 class="mt-4 font-bold">5.4 Custos adicionais</h3>
        <p class="mt-1">
          Tributos, encargos financeiros, taxas cambiais ou valores cobrados pela operadora do cartão ou instituição financeira são de responsabilidade exclusiva do usuário.
        </p>

        <h3 class="mt-4 font-bold">5.5 Reembolsos</h3>
        <p class="mt-1">
          Pagamentos já processados não são reembolsáveis, salvo disposição legal obrigatória, erro de cobrança comprovado ou previsão expressa em oferta específica.
        </p>

        <h3 class="mt-4 font-bold">5.6 Contestação indevida</h3>
        <p class="mt-1">
          Em caso de contestação manifestamente indevida de cobrança regularmente autorizada, a Casato poderá adotar medidas razoáveis de verificação, incluindo suspensão temporária do acesso, sem prejuízo das medidas cabíveis.
        </p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">6. Simulações, Dados e Processamento Automatizado</h2>

        <h3 class="mt-4 font-bold">6.1 Base das simulações</h3>
        <p class="mt-1">
          As simulações são baseadas em parâmetros inseridos pelo usuário e premissas automatizadas.
        </p>

        <h3 class="mt-4 font-bold">6.2 Fontes de informação</h3>
        <p class="mt-1">
          Informações podem ser estruturadas a partir de dados públicos, informações de terceiros e processamento automatizado, incluindo inteligência artificial.
        </p>

        <h3 class="mt-4 font-bold">6.3 Limitações técnicas</h3>
        <p class="mt-1">
          Sistemas automatizados estão sujeitos a limitações técnicas e podem apresentar imprecisões, indisponibilidades ou desatualizações.
        </p>

        <h3 class="mt-4 font-bold">6.4 Sem garantia absoluta</h3>
        <p class="mt-1">
          A Casato não garante exatidão absoluta, completude ou atualização contínua dos dados.
        </p>

        <h3 class="mt-4 font-bold">6.5 Decisão do usuário</h3>
        <p class="mt-1">
          Toda decisão de participar de leilões ou realizar investimentos é de responsabilidade exclusiva do usuário.
        </p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">7. Alertas e Notificações</h2>

        <h3 class="mt-4 font-bold">7.1 Natureza dos alertas</h3>
        <p class="mt-1">Alertas possuem natureza automatizada e informativa.</p>

        <h3 class="mt-4 font-bold">7.2 Entrega de alertas</h3>
        <p class="mt-1">
          A Casato não garante envio em tempo real, entrega imediata ou recebimento efetivo pelo usuário.
        </p>

        <h3 class="mt-4 font-bold">7.3 Acompanhamento oficial</h3>
        <p class="mt-1">
          O acompanhamento oficial de prazos, editais, condições e alterações permanece sob responsabilidade exclusiva do usuário.
        </p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">8. Comunicações</h2>
        <p class="mt-1">
          A Casato poderá enviar comunicações relacionadas à utilização da Plataforma, incluindo informações sobre a conta, funcionalidades, atualizações, alertas e aspectos operacionais do serviço.
        </p>
        <p class="mt-1">
          O envio de comunicações promocionais, conteúdos ou ofertas dependerá de consentimento do usuário, quando exigido pela legislação aplicável.
        </p>
        <p class="mt-1">
          O usuário poderá, a qualquer momento, optar por não receber comunicações promocionais, sem prejuízo do recebimento de comunicações estritamente necessárias ao funcionamento da conta ou do serviço.
        </p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">9. Dados Pessoais</h2>

        <p class="mt-1">
          Para operação da Plataforma, poderão ser tratados dados estritamente necessários para cadastro, autenticação, cobrança, segurança da conta e suporte ao usuário.
        </p>

        <p class="mt-1">
          A Casato poderá utilizar prestadores especializados para hospedagem, autenticação, pagamentos, comunicações e infraestrutura tecnológica, incluindo Amazon Web Services e Stripe.
        </p>

        <p class="mt-1">
          O tratamento de dados pessoais ocorre conforme descrito na Política de Privacidade aplicável.
        </p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">10. Disponibilidade da Plataforma</h2>
        <p class="mt-1">
          A Plataforma poderá sofrer interrupções temporárias para manutenção, ajustes técnicos, atualizações de segurança, falhas de terceiros, falhas de telecomunicações ou eventos fora do controle razoável da Casato.
        </p>
        <p class="mt-1">
          Não há garantia de disponibilidade contínua ou ininterrupta.
        </p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">11. Propriedade Intelectual</h2>
        <p class="mt-1">
          Todo o conteúdo, estrutura tecnológica, marcas, códigos, software, layout, relatórios e bases de dados são protegidos por legislação aplicável e pertencem à Casato ou a seus licenciadores.
        </p>
        <p class="mt-1">
          O uso da Plataforma não transfere qualquer direito de propriedade intelectual ao usuário.
        </p>
        <p class="mt-1">É vedado, sem autorização prévia e expressa da Casato:</p>
        <ul class="mt-1 list-disc pl-6">
          <li>copiar, reproduzir ou redistribuir conteúdos em escala relevante</li>
          <li>realizar scraping, mineração automatizada ou coleta massiva de dados</li>
          <li>revender acessos ou sublicenciar contas</li>
          <li>tentar engenharia reversa da Plataforma</li>
          <li>utilizar a Plataforma para fins ilícitos ou concorrenciais indevidos</li>
        </ul>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">12. Limitação de Responsabilidade</h2>
        <p class="mt-1">A Casato não se responsabiliza por:</p>
        <ul class="mt-1 list-disc pl-6">
          <li>decisões tomadas com base nas informações disponibilizadas</li>
          <li>atos de leiloeiros, instituições financeiras ou órgãos públicos</li>
          <li>falhas técnicas, indisponibilidade ou erros de terceiros</li>
          <li>interrupções temporárias da Plataforma</li>
          <li>perda de oportunidades decorrente de alertas não recebidos ou recebidos com atraso</li>
          <li>uso indevido da conta pelo usuário decorrente de negligência na guarda de credenciais</li>
        </ul>
        <p class="mt-1">
          Nada nestes Termos exclui responsabilidade nos casos em que a exclusão seja vedada por lei aplicável.
        </p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">13. Suspensão ou Encerramento de Conta</h2>
        <p class="mt-1">A Casato poderá suspender ou encerrar contas em caso de:</p>
        <ul class="mt-1 list-disc pl-6">
          <li>violação destes Termos</li>
          <li>fraude ou suspeita razoável de fraude</li>
          <li>uso indevido da Plataforma</li>
          <li>compartilhamento indevido de conta</li>
          <li>inadimplência relacionada à assinatura</li>
          <li>exigência legal ou regulatória</li>
        </ul>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">14. Legislação Aplicável e Foro</h2>
        <p class="mt-1">
          Estes Termos serão interpretados conforme a legislação aplicável à relação jurídica, observadas normas obrigatórias de proteção ao consumidor quando existentes.
        </p>
        <p class="mt-1">
          Fica eleito, na medida permitida por lei, o foro competente dos Países Baixos, sem prejuízo do foro do domicílio do consumidor quando norma imperativa determinar o contrário.
        </p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">15. Alterações dos Termos</h2>
        <p class="mt-1">
          A Casato poderá modificar estes Termos a qualquer momento.
        </p>
        <p class="mt-1">
          A continuidade do uso da Plataforma após a publicação das alterações poderá ser interpretada como aceitação das novas condições, quando permitido por lei.
        </p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">16. Disposições Gerais</h2>
        <p class="mt-1">
          A eventual invalidade, nulidade ou inexigibilidade de qualquer disposição destes Termos não afetará as demais cláusulas, que permanecerão em pleno vigor.
        </p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">17. Contato</h2>
        <p class="mt-1">Em caso de dúvidas relacionadas a estes Termos:</p>
        <p class="mt-1">
          <a href="mailto:contato&#64;casatobrasil.com.br" class="text-blue-600 hover:underline">contato&#64;casatobrasil.com.br</a>
        </p>
      </section>
    </div>
  </div>
</div>
